import { COLORS } from 'src/theme/palette';
import { makeStyles } from 'src/utils/makeStyles';

const styles = makeStyles({
  input: {
    paddingRight: 0,
  },
  visibilityButton: {
    '& svg': {
      fill: COLORS.black40,
    },
  },
});

export default styles;
